module.exports = __webpack_public_path__ + "img/2.464f82d1.webp";